import { React, useCallback, useEffect, useState } from "react";
import { Outlet, useLoaderData, useLocation, useSearchParams } from "react-router-dom";
import { useCookies } from "react-cookie";
import useLocalStorage from "use-local-storage";
import Cookies from 'js-cookie';
import jwt_decode from "jwt-decode";

//styles
import './styles/index.scss';

// Bootstrap JS is required for some functionality
import "bootstrap/dist/js/bootstrap.bundle.min";

//pages
import Login from "./pages/Login";
import Header from "./components/Header";
import WorkflowContext from "./workflowContext";
import authApiService from "./services/authApiService";
import { updateAxioswithcookie } from "./services/upload-files.service";
import { RelayEnvironmentProvider } from "react-relay";
import environment from './services/relayEnvironment'


function getSessionStorageOrDefault(key, defaultValue) {
    const stored =  sessionStorage.getItem(key);
    if (!stored) {
      return defaultValue;
    }
    return JSON.parse(stored);

  }


 function App() {
    const { pathname } = useLocation();

    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const [cookies, setCookie, removeCookie] = useCookies(['auth', 'userid']);

    const [apitoken, setApitoken] = useState(
        getSessionStorageOrDefault('apitoken', null)
    );

    const [token, setToken] = useState("");
    const [refreshtokenNow, setRefreshTokenNow] = useState(false);
    const [reftoken, setRefToken] = useState("");

    useEffect(() => {
        setApitoken(getSessionStorageOrDefault('apitoken', null));
    });

    useEffect(() => {
        const fetchToken = async () => {
            // return Cookies.get('token');
            return sessionStorage.getItem('p3token');
        }

        fetchToken().then(thistoken => {
            if (thistoken === null) {
                return;
            }

            Cookies.set('token', JSON.parse(thistoken), { sameSite: 'strict', secure: true });

            manageToken(thistoken);
        });
    });

    // useEffect(() => {
    //     if (settingParam) {
    //         setSettingParam(false);
    //         return;
    //     } 
    //     const queryWorkflow = searchParams.get('workflow');
    //     if (queryWorkflow) setWorkflowAndCache(queryWorkflow, true);
    // }, [searchParams, settingParam, setWorkflowAndCache])




    useEffect(() => {

        if (refreshtokenNow === true) {

            authApiService.refreshTokenApi(environment,token).then(result => {
                // let reftoken = result.refreshToken.token;
                const tempRefToken = result.refreshToken.token;
                setRefToken(tempRefToken);

                Cookies.set('token', tempRefToken, { sameSite: 'strict', secure: true });
            });
        }
    }, [refreshtokenNow, reftoken, token]);

    useEffect(() => {

        if (reftoken !== "") {

            authApiService.getAllUserTokenQueryApi(reftoken)
                .then(res =>{
                    let usertoken;

                    if (res && res.length > 0) {
                        usertoken = res[0].token;
                    }
                    Cookies.set('Useraccesstoken', usertoken, { sameSite: 'strict', secure: true });

                    setCookie('auth', usertoken, {
                        path: '/',
                        maxAge: 600,
                        secure: true,
                        sameSite: 'strict'
                    });
                    updateAxioswithcookie(Cookies.get('Useraccesstoken'))
            });

        } else {
            setIsAuthenticated(false);
        }

    }, [reftoken, setCookie]);

    const manageToken = (proptoken) => {

        let isAuth = isAuthenticated;

        if (proptoken !== null) {
            const anotherToken = JSON.parse(proptoken);
            setToken(anotherToken);

            isAuth = true;
            setIsAuthenticated(isAuth);
        }

        if ( (isAuthenticated === true || isAuth === true) && token !== undefined && token !== null && token !== "") {
            // setTokenValue(token);
            //setting up the refresh token condition

            let parseJwt = jwt_decode(token);
            let expDate = new Date(parseJwt.exp * 1000);
            let origDate = new Date(parseJwt.origIat * 1000)
            let expirationThreshold = expDate - 60000;

            if (Date.now() >= expirationThreshold) {

                setRefreshTokenNow(true);

                // authApiService.refreshTokenApi(environment,token).then(result => {
                //     let reftoken = result.refreshToken.token;
                //     Cookies.set('token', reftoken, { sameSite: 'strict', secure: true });
                //     authApiService.getAllUserTokenQueryApi(reftoken).then(res =>{
                //         let usertoken;
                //         if (res.length > 0) {
                //             usertoken = res[0].token;
                //         }
                //         Cookies.set('Useraccesstoken', usertoken, { sameSite: 'strict', secure: true });

                //         setCookie('auth', usertoken, {
                //             path: '/',
                //             maxAge: 600,
                //             secure: true,
                //             sameSite: 'strict'
                //         });
                //         updateAxioswithcookie(Cookies.get('Useraccesstoken'))
                //     });
                // });

                //call refreshtoken method
            }

            setRefreshTokenNow(false);

        } else {
            setIsAuthenticated(false);
            // sessionStorage.clear();
            // setTokenValue("");
        }
    }

    if (isAuthenticated !== true) {
        // sessionStorage.clear();
        return (
            <RelayEnvironmentProvider environment={environment}>
                <Login setIsAuthenticated={setIsAuthenticated} />
            </RelayEnvironmentProvider>
        )
    }
    
    return (
        <RelayEnvironmentProvider environment={environment}>
            { apitoken  && pathname !== "/login" && apitoken &&
                <Header setIsAuthenticated={setIsAuthenticated} className="col"/>
            }
            <Outlet />
        </RelayEnvironmentProvider>
    );
}


export default App;